import React, { useState ,useEffect} from "react";
import { useFormik } from "formik";

import Field from "./components/Template/Field";

import Button from "./components/UI/Button";
import Input from "./components/UI/Input";
import Select from "./components/UI/Select";

import Calculate from "./components/Calculate";
import { validationSchema } from "./components/validationSchema";

// app
function App() {
  const [result, setResult] = useState({})
  const [version, setVersion] = useState (null)
  const [year, setYear] = useState (null)

  const formik = useFormik({
    initialValues: {
      numberMontoInvertir: '',
      numberCantDias: '',
      selectBanco: '',
      
    },
    validationSchema,
    validateOnChange: true, 
    validateOnBlur: true,
    validateOnMount: true,
    onSubmit: (values) => {
      console.log("Datos del formulario:", values);
    }
  });

  const [banco, setBanco] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://calculadoras-statics.agea.com.ar/calculadora-tna.json');
        if (!response.ok) {
          throw new Error('Error al obtener datos');
        }
        const data = await response.json();

        const newOptions = data.map(item => ({
          value: item.tna,
          label: item.banco
        }));
        
        setBanco(newOptions);
      } catch (error) {
        console.error("Error al cargar datos:", error);
        // Mantiene las opciones por defecto en caso de error
      }
    };
    
    fetchData();
  }, []);

  console.log("Banco: ", banco);
  const handleValueChange = (name, value) => {
    let formattedValue = isNaN(value) ? null : value;
    formik.setFieldValue(name, formattedValue);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await formik.validateForm();
    if (!formik.isValid) {
      setResult({})
      console.log("Errores en el formulario, no se puede enviar => ",formik.values);
      return;
    }
    formik.handleSubmit();
    const result = await Calculate(formik.values); 
    setResult(result);
    //console.log("Resultado: :", result);
  };

  useEffect(() => {
    setVersion(process.env.REACT_APP_TAG_NUMBER ?? '00.00.00');
    setYear(new Date().getFullYear());
  }, [version,year]);
  
  return (
    <>
      <div className="max-w-[700px] mx-auto px-6 py-6 shadow-lg md:px-14 bg-white">
        <form onSubmit={handleSubmit}>

          <Field label='Ingresa el monto a invertir'> 
            <Input name='numberMontoInvertir' placeholder='0' dropdown={false} value={formik.values.numberMontoInvertir}
              error={formik.errors.numberMontoInvertir}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              touched={formik.touched.numberMontoInvertir}
              onValueChange={(name, value) => {
                handleValueChange(name, value);
              }}
              required={true}
            /> 
          </Field>
          <Field label='Indica la cantidad de dias'> 
            <Input name='numberCantDias' placeholder='0' dropdown={false} value={formik.values.numberCantDias}
              error={formik.errors.numberCantDias}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              touched={formik.touched.numberCantDias}
              onValueChange={(name, value) => {
                handleValueChange(name, value);
              }}
              required={true}
            /> 
          </Field>

          <Field label='Seleccione el banco'>
            <Select  
              name="selectBanco"
              options={banco}
              value={formik.values.selectBanco}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.selectBanco}
              touched={formik.touched.selectBanco} 
              required={true}            
            />     
          </Field>


          <Button name="Calcular" />
        </form>

        <div>
          <div className="flex flex-col md:flex-row py-4 border-t border-gray-300">
            <div className="basis-1/2">
              <label className="text-sm font-bold uppercase">
                Monto total ganado
              </label>
              <p className="text-4xl font-bold text-gray-clarin my-3">
                $ {result["montoGanadoTotal"] ? result["montoGanadoTotal"] : "_"}
              </p>
            </div>

          </div>
          <div className="py-4 border-t border-gray-300">
            <p className="mb-2">Este monto incluye los siguientes ítems</p>
            <p className="font-bold text-gray-clarin">
              Invertiste: $ {result["montoInvertido"] ? result["montoInvertido"] : "_"}
            </p>
            <p className="font-bold text-gray-clarin">
              Monto ganado: $ {result["montoGanado"] ? result["montoGanado"] : "_"}
            </p>
            <p className="font-bold text-gray-clarin">
              Banco Seleccionado:  {result["banco"] ? result["banco"] : "_"}
            </p>
            <p className="font-bold text-gray-clarin">
              TNA: % {result["TNA"] ? result["TNA"] : "_"}
            </p>
            <p className="font-bold text-gray-clarin">
              TEA: % {result["TEA"] ? result["TEA"] : "_"}
            </p>
            

          </div>
          
          <div className="py-4 border-t border-gray-300">
            <p className="text-xs">
              Calculadora de TNA ©{year}. Todos los derechos
              reservados v{version}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
